import { useEffect, useState } from 'react';
import { isSsr } from '../utils';
import { useIsClientSide } from './Media.utils';
function useIsMediaQuery(query) {
  const isClientSide = useIsClientSide();
  const [isMatch, setIsMatch] = useState(() => {
    if (isSsr()) {
      return false;
    }
    return window.matchMedia(query).matches;
  });
  useEffect(() => {
    const queryMedia = window.matchMedia(query);
    function handleChange(event) {
      setIsMatch(event.matches);
    }
    queryMedia.addEventListener('change', handleChange);
    return () => {
      queryMedia.removeEventListener('change', handleChange);
    };
  }, [query, isClientSide]);
  return isClientSide ? isMatch : false;
}
export { useIsMediaQuery };